export default "__VITE_ASSET__DK6ZHM0d__"